module.exports = __webpack_public_path__ + "static/media/email-white.0cce4cfa.png";